var _path, _path2, _path3, _path4, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGraphic2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 2017 2334",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m104.32 1081.7h492.94c0-269.27 222.48-490.83 492.88-490.83v-490.89h-985.82v981.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m104.32 1081.7h492.94c0-269.27 222.48-490.83 492.88-490.83v-490.89h-985.82v981.72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1090.1 2233.3v-490.89c-270.4-0-492.88-221.56-492.88-490.83h-492.94v981.72h985.82z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1090.1 2233.3v-490.89c-270.4-0-492.88-221.56-492.88-490.83h-492.94v981.72h985.82z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1258.7,
    y: 1742.4,
    width: 653.61,
    height: 490.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1258.7,
    y: 99.998,
    width: 653.61,
    height: 490.89
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGraphic2);
export default __webpack_public_path__ + "static/media/logo_graphic_2.2692363b23dd124f5fcb2addeeec3c2e.svg";
export { ForwardRef as ReactComponent };